import { Flex } from "@chakra-ui/react";
import { Modal } from "antd";
import FooterModal from "components/Button/FooterModal";
import { OperacaoEnum } from "core/resources/enums/conta";
import moment from "moment";
import useFiltroContaRecorrente from "./../../hooks/useFiltroContaRecorrente";
import TableContaRecorrente from "./../TableContaRecorrente/index";
interface ModalTableContaRecorrenteProps {
  operacao: OperacaoEnum;
  isOpen: boolean;
  onClose: () => any;
  refetch?: () => any;
  mes?: string;
  ids?: string[];
}

function ModalTableContaRecorrente({
  operacao,
  isOpen,
  onClose,
  refetch,
  mes = moment().format("YYYY-MM"),
  ids,
}: ModalTableContaRecorrenteProps) {
  const { filtro, onChangeFiltro } = useFiltroContaRecorrente(operacao, {
    mes,
    ids,
    operacao,
  });

  const getTitle = () => {
    let title = "";

    if (operacao === OperacaoEnum.Despesa) {
      title += "Despesas ";
    } else {
      title += "Receitas ";
    }

    title += `recorrentes não lançadas - ${moment(mes, "YYYY-MM").format(
      "MMMM [de] YYYY"
    )}`;

    return title;
  };

  return (
    <Modal
      centered
      visible={isOpen}
      footer={
        <FooterModal
          onClose={onClose}
          showRegisterAnother={false}
          hidePrimaryButton
          buttonCancelarText="Fechar"
        />
      }
      title={getTitle()}
      destroyOnClose
      onCancel={onClose}
      maskClosable={false}
      closable={true}
      width={"min(1200px, 80vw)"}
      bodyStyle={{
        maxHeight: "70vh",

        paddingBottom: 16,
      }}
    >
      <Flex
        flexDir="column"
        mt={-4}
        id="lista-lancamentos-conta-corrente"
        overflow="auto"
        overflowX="hidden"
        maxH="70vh"
      >
        <TableContaRecorrente
          filtro={filtro}
          operacao={operacao}
          onChangeFiltro={onChangeFiltro}
          refetch={refetch}
        />
      </Flex>
    </Modal>
  );
}

export default ModalTableContaRecorrente;
